import { h } from "preact";
import { useState, useEffect } from "preact/hooks";
import {
	Box,

	Button,
	Checkbox,
	DialogActions,
	DialogContent,
	Dialog,
	DialogTitle,
	FormControlLabel,
	Grid,
	MenuItem,
	TextField,
	Typography,
} from "@mui/material";

export default function UpdatePictureDialog(props) {
	const [form, setForm] = useState({ confirm: "", comment: props.state.params.pic.cmt });
	const [disabled, setDisabled] = useState(false);
	const handleClose = () => {
		props.onClose();
	};
	const handleChange = (event) => {
		setForm({ ...form, [event.target.name]: event.target.value });
	};

	useEffect(() => {

		// setDisabled(!(form.comment !== state.comment));
	}, [form]);

	const handleSubmitUpdatePicture = () => {
		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ cmt: form.comment, uid: props.state.params.pic.uid }),
		};
		fetch("/api/9f80dde74e014dd8a6ac5f6ac8ecb53f/", requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":

						window.location.reload();
						break;

					case "err":
						break;
					default:
						break;
				}
			});
	};
	const handleChangeCheckbox = (event) => {
		setForm({ ...form, [event.target.name]: event.target.checked });
	};
	return (
		<Dialog onClose={handleClose} aria-labelledby="add-user-dialog" open={props.state.opened} maxWidth="md" fullWidth={false}>
			<DialogTitle id="add-user-dialog">Edition d'une image</DialogTitle>
			<DialogContent dividers>
				<Typography variant="body1" gutterBottom>
					Vous pouvez ajouter un commentaire à la photo
				</Typography>

				<div>
					<Grid container spacing={2} alignItems="center">
						{false && (
							<Grid item xs={12}>
								<FormControlLabel
									control={<Checkbox checked={state.is_owner} onChange={handleChangeCheckbox} name="is_owner" color="primary" />}
									label="Cette photo est l'image principale du dossier"
								/>
							</Grid>
						)}
						<Grid item xs={12}>
							<TextField
								id="comment"
								name="comment"
								variant="outlined"
								style={{
									marginLeft: 0,
									marginRight: 10,
								}}
								placeholder="Commentaire"
								fullWidth
								multiline
								rows={3}
								margin="dense"
								size="small"
								value={form.comment}
								onChange={handleChange}
							/>
						</Grid>
						{false && <Grid item xs={12}>
							<Typography variant="body1" display="inline">
								Vous pouvez modifier l'ordre d'apparition des photos
							</Typography>
							<TextField
								id="rank"
								name="rank"
								select
								style={{
									marginLeft: 10,
									marginRight: 10,
								}}
								margin="dense"
								value={form.rank}
								onChange={handleChange}
							>
								{state.pics &&
									state.pics.map((option) => (
										<MenuItem key={option.uid} value={option.rnk}>
											{option.rnk}
										</MenuItem>
									))}
							</TextField>
							<div>
								<Typography variant="caption">La photo n°1 est la photo principale du dossier de vente</Typography>
							</div>
						</Grid>}
					</Grid>
				</div>
			</DialogContent>

			<DialogActions>

				<Box display="flex" justifyContent="space-between" alignItems="space-between" style="width: 100%;">
					<Box>
						<Button variant="outlined" onClick={handleClose}>
							Annuler
						</Button>
					</Box>
					<Box>
						<Button
							variant="contained"
							onClick={handleSubmitUpdatePicture}

							disabled={disabled}
						>
							Modifier
						</Button>
					</Box>
				</Box>


			</DialogActions>
		</Dialog>
	);
}
